import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

    @Input() label: string;
    /*
    * 'primary' | 'secondary' | 'ternary'
    * */
    @Input() color: string;
    /*
    * 'large' | 'small' | 'mini'
    * */
    @Input() dimension: string;

    @Input() icon: string;

    @Input() isDisabled: boolean = false;

}
